import React from 'react';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import './BeamGlobInfo.css';

/**
 * BeamGlobInfo — informational body shown when the Beam button is tapped
 * while the user is in #GLOB.
 *
 * Beam is intentionally party-only: #GLOB is the global cloud chat room
 * (too large for a peer-to-peer mesh) and `MeshProvider` skips signaling
 * entirely for partyCode === 'GLOB'. Rather than opening the radar to an
 * empty list, the nav surfaces this short explainer with two CTAs that
 * route the user into the existing PartyModal.
 *
 * Props
 *  - onThrowParty : () => void  — caller opens PartyModal with `initialTab="throw"`
 *  - onJoinParty  : () => void  — caller opens PartyModal with `initialTab="join"`
 *
 * Caller wraps this in <Modal>. We don't include the Modal scaffold here so
 * the nav components can pick variant (sheet on mobile, card on desktop)
 * and pass `bare` if they want to keep the close button uncluttered.
 */
const BeamGlobInfo = ({ onThrowParty, onJoinParty }) => (
  <div className="beam-glob-info" data-testid="beam-glob-info">
    <div className="beam-glob-info__icon" aria-hidden="true">
      <Icon name="lan" size={36} stroke="var(--lan, #3fdc8a)" />
    </div>
    <h2 className="beam-glob-info__title">Beam drop is for parties</h2>
    <p className="beam-glob-info__body">
      You're in <b>#GLOB</b>, the global cloud chat. To send files
      device-to-device over your network, create or join a private party.
    </p>
    <div className="beam-glob-info__actions">
      <Button variant="primary" onClick={onThrowParty}>
        Throw a party
      </Button>
      <Button variant="ghost" onClick={onJoinParty}>
        Join a party
      </Button>
    </div>
  </div>
);

export default BeamGlobInfo;
